import { EntityType, EntityInstance } from "./Entities";

export class EntityInstanceEditorScreenData {

    entityInstance: EntityInstance;
    entityType: EntityType;
    snackbar: Object;
    loading: boolean;

    constructor(){
        this.entityInstance = null
        this.entityType = null
        this.snackbar = {
            ['isVisible']: false,
            text: '',
            color: '',
            timeout: 3000,
        }
        this.loading = false
    }

    success_message(message:string){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'success'
        this.snackbar['isVisible'] = true
    }

    error_message(message:string){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'error'
        this.snackbar['isVisible'] = true
    }


}